import { SvgIcon } from "@progress/kendo-react-common";
import { xIcon } from "@progress/kendo-svg-icons";

export const CrossIcon = ({ onClick, selected, disabled }) => (
  <span
    role="button"
    tabIndex={disabled ? -1 : 0}
    aria-label="Close tab"
    aria-disabled={disabled || undefined}
    onClick={(e) => {
      e.stopPropagation();
      if (disabled) return;
      onClick && onClick(e);
    }}
    onKeyDown={(e) => {
      if (disabled) return;
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        onClick && onClick(e);
      }
    }}
    className={`tabs-remove-icon-wrapper ms-3 d-flex justify-content-center align-items-center ${
      disabled ? "" : "cursor-pointer"
    }`}
    style={
      disabled
        ? { opacity: 0.35, cursor: "not-allowed", pointerEvents: "none" }
        : undefined
    }
  >
    <SvgIcon
      icon={xIcon}
      className={selected ? "r-icon" : "r-icon-unselected"}
    />
  </span>
);

const Title = (props) => {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        height: "100%",
        ...props.style,
      }}
      className="tab-title"
    >
      <div
        className={`d-flex`}
        style={{
          color: props.selected === props.content ? "black" : "#757575",
          fontWeight: props.selected === props.content ? "bold" : "",
        }}
      >
        <span
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            maxWidth: props.maxWidth,
          }}
        >
          {props.content}
        </span>
        <CrossIcon
          onClick={() => props.onTabRemove(props.content)}
          selected={props.selected === props.content}
        />
      </div>
    </div>
  );
};

export default Title;
